<template>
  <div>
    <div class="fs-xl fw-500 text-dark mb-16px">{{ `${$t('label.ticket')} #${ticketId}` }}</div>
    <ticket-messenger
        class="messenger-wrapper"
        :ticket="ticket"
        with-image-upload
        @send="sendMessage"
        @close="showCloseTicketModal"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import TicketMessenger from '@/components/custom/TicketMessenger';

export default {
  components: {
    TicketMessenger
  },
  data: () => ({
    echoChannel: null,
    echoEvent: null,
    ticketId: null
  }),
  beforeMount() {
    // Le ticket d'abord : le temps réel ne doit pas pouvoir empêcher de l'afficher.
    this.ticketId = this.$route.params.id;
    this.getTicket();

    this.echoChannel = `user.${this.profile.id}`;
    this.echoEvent = '.ticket_support_added_message';
    this.listen();
  },
  computed: {
    ...mapGetters({
      profile: 'me',
      ticket: 'ticketsStore/TICKET'
    })
  },
  methods: {
    getTicket() {
      this.$store.dispatch('ticketsStore/GET_TICKET', this.ticketId);
    },
    sendMessage(data) {
      let formData = new FormData();
      formData.append('message', data.message);
      if (data.attachment) formData.append('attachment', data.attachment);

      this.$store.dispatch('ticketsStore/SEND_MESSAGE', {ticketId: this.ticketId, data: formData});
    },
    showCloseTicketModal() {
      this.$confirm({
        title: this.$t('modal.close_ticket'),
        centered: true,
        closable: true,
        okType: 'primary',
        cancelText: this.$t('btn.no'),
        okText: this.$t('btn.yes'),
        onOk: () => {
          this.$store.dispatch('ticketsStore/CHANGE_STATUS', {id: this.ticket.id, status: 2})
          .then(() => {
            this.getTicket();
            this.$message.success(this.$t('alert.ticket_closed'));
          })
          .catch(error => {
            this.$message.error(error.response.data?.error?.message || this.$t('alert.something_goes_wrong'));
          });
        },
        onCancel: () => {
          console.log('cancel');
        },
      });
    },
    listen() {
      this.$echo.private(this.echoChannel).listen(this.echoEvent, () => this.getTicket());
    }
  },
  beforeDestroy() {
    this.$echo.leave(this.echoChannel);
    this.$store.commit('ticketsStore/CLEAR_TICKET');
  }
}
</script>

<style lang="scss" scoped>
.messenger-wrapper::v-deep {
  .messages-wrapper {
    height: 35vh;
  }
}
</style>

<style lang="scss" scoped>
@media screen and (max-height: 820px) {
  .messenger-wrapper::v-deep {
    .messages-wrapper {
      height: 30vh;
    }
  }
}
</style>